<template>
  <b-modal ref="purchase"
           size="xl"
           :hide-footer="true"
           scrollable
           @hide="$emit('hide')"
  >
    <template #modal-header>
      <div class="d-flex align-items-center col-12">
        <img src="https://static.zopone.com.br/img/logotipo/header/zopone.png" style="width: 45px" />
        <span class="modalTitle ml-auto">
          {{$lang.PCI.PurchaseOrder.Title}}
        </span>
        <button class="close" @click="onClose">x</button>
      </div>
    </template>
    <div v-show="!rowSelected" class="w-100 h-100">
      <div class="d-flex justify-content-end" style="height: 35px;">
        <i class="fas fa-file-excel text-third" style="font-size: 24px;" @click="exportExcel" v-b-tooltip.hover.topleft :title="'Exportar Excel'"></i>
      </div>
      <div class="d-flex flex-wrap" style="height: calc(100% - 185px);">
        <ag-grid-vue class="ag-theme-alpine"
                      :getLocaleText="localeTextFunc"
                      :defaultColDef="defaultColumnDef"
                      :gridOptions="purchaseOrderGridOptions"
                      :columnTypes="columnTypes"
                      :columnDefs="columnDefs"
                      :rowData="data"
                      :suppressContextMenu="true"
                      suppressHorizontalScroll
                      :stopEditingWhenCellsLoseFocus="true"
                      :groupHeaderHeight="45"
                      :headerHeight="45"
                      :rowHeight="30"
                      :excelStyles="purchaseExcelStyles"
                      @cellDoubleClicked="onSelect"
                      style="width:100%;height:100%;"/>
      </div>
      <div class="d-flex flex-wrap align-items-center" style="height: 150px;">
        <div class="col-5"></div>
        <div class="col-2 mt-1 pt-2 align-items-center">
          <b-form-group :label="$lang.PCI.PurchaseOrder.LabelDelivered" label-cols="5" label-align="right" content-cols="7">
            <b-form-input :disabled="true" v-model="valorEntregue" class="text-right"></b-form-input>
          </b-form-group>
          <b-form-group :label="$lang.PCI.PurchaseOrder.LabelToDeliver" label-cols="5" label-align="right" content-cols="7">
            <b-form-input :disabled="true" v-model="valorAEntregar" class="text-right"></b-form-input>
          </b-form-group>
          <b-form-group :label="$lang.PCI.PurchaseOrder.LabelTotal" label-cols="5" label-align="right" content-cols="7">
            <b-form-input :disabled="true" v-model="valorTotal" class="text-right"></b-form-input>
          </b-form-group>
        </div>
        <div class="col-5"></div>
      </div>
    </div>
    <div v-if="rowSelected" class="w-100 h-100" style="overflow-y: auto;">
      <div class="d-flex p-2">
        <b-button @click="onShowGrid" variant="third">
          <i class="fas fa-angle-double-left mx-2"></i>
        </b-button>
        <b-button @click="onPrint" variant="third" class="ml-2">
          <i class="fas fa-print mx-2"></i>
        </b-button>
      </div>
      <b-tabs>
        <b-tab :title="$lang.PCI.PurchaseOrder.Detail.TabPurchaseOrder">
          <b-row>
            <b-col cols="2">
              <b-form-group :label="$lang.PCI.PurchaseOrder.Detail.LabelPurchaseOrder">
                <b-input disabled v-model="purchaseDetail.ordem"></b-input>
              </b-form-group>
            </b-col>
            <b-col cols="2">
              <b-form-group :label="$lang.PCI.PurchaseOrder.Detail.LabelOrder">
                <b-input disabled v-model="purchaseDetail.pedido"></b-input>
              </b-form-group>
            </b-col>
            <b-col cols="2">
              <b-form-group :label="$lang.PCI.PurchaseOrder.Detail.LabelResponsible">
                <b-input disabled v-model="purchaseDetail.responsavel"></b-input>
              </b-form-group>
            </b-col>
            <b-col cols="2">
              <b-form-group :label="$lang.PCI.PurchaseOrder.Detail.LabelDirector">
                <b-input disabled v-model="purchaseDetail.diretor"></b-input>
              </b-form-group>
            </b-col>
            <b-col cols="2">
              <b-form-group :label="$lang.PCI.PurchaseOrder.Detail.LabelEmission">
                <b-input disabled v-model="purchaseDetail.emissao"></b-input>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <b-card :header="$lang.PCI.PurchaseOrder.Detail.CardConstruction" class="m-2">
                <b-row>
                  <b-col cols="2">
                    <b-form-group :label="$lang.PCI.PurchaseOrder.Detail.LabelConstruction">
                      <b-form-input disabled v-model="purchaseDetail.obra"></b-form-input>
                    </b-form-group>
                  </b-col>
                  <b-col cols="3">
                    <div class="d-flex flex-column">
                      <b-form-group>
                        <b-form-input disabled v-model="purchaseDetail.contrato"></b-form-input>
                      </b-form-group>
                      <b-form-group>
                        <b-form-input disabled v-model="purchaseDetail.idSite"></b-form-input>
                      </b-form-group>
                    </div>
                  </b-col>
                  <b-col cols="7">
                    <b-form-group :label="$lang.PCI.PurchaseOrder.Detail.LabelDelivery">
                      <b-form-input disabled v-model="purchaseDetail.localEntrega"></b-form-input>
                    </b-form-group>
                  </b-col>
                </b-row>
              </b-card>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="5">
              <b-card :header="$lang.PCI.PurchaseOrder.Detail.CardTransport" class="m-2">
                <b-row>
                  <b-col cols="2">
                    <b-form-group :label="$lang.PCI.PurchaseOrder.Detail.LabelCode">
                      <b-form-input disabled v-model="purchaseDetail.codTransportador"></b-form-input>
                    </b-form-group>
                  </b-col>
                  <b-col cols="10">
                    <b-form-group :label="$lang.PCI.PurchaseOrder.Detail.LabelName">
                      <b-form-input disabled v-model="purchaseDetail.transportador"></b-form-input>
                    </b-form-group>
                  </b-col>
                </b-row>
              </b-card>
            </b-col>
            <b-col cols="7" class="pl-0">
              <b-card :header="$lang.PCI.PurchaseOrder.Detail.CardCustomer" class="m-2">
                <b-row>
                  <b-col cols="2">
                    <b-form-group :label="$lang.PCI.PurchaseOrder.Detail.LabelCode">
                      <b-form-input disabled v-model="purchaseDetail.codTransportador"></b-form-input>
                    </b-form-group>
                  </b-col>
                  <b-col cols="10">
                    <b-form-group :label="$lang.PCI.PurchaseOrder.Detail.LabelName">
                      <b-form-input disabled v-model="purchaseDetail.transportador"></b-form-input>
                    </b-form-group>
                    <b-form-checkbox disabled v-model="purchaseDetail.comServico">{{ $lang.PCI.PurchaseOrder.Detail.LabelWithService }}</b-form-checkbox>
                  </b-col>
                </b-row>
              </b-card>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <b-card :header="$lang.PCI.PurchaseOrder.Detail.CardComplementary" class="m-2">
                <b-row>
                  <b-col cols="2">
                    <b-form-group :label="'IPI'">
                      <b-form-input type="number" disabled v-model="purchaseDetail.ipi"></b-form-input>
                    </b-form-group>
                  </b-col>
                  <b-col cols="2">
                    <b-form-group :label="$lang.PCI.PurchaseOrder.Detail.LabelPackaging">
                      <b-form-input type="number" disabled v-model="purchaseDetail.embalagem"></b-form-input>
                    </b-form-group>
                  </b-col>
                  <b-col cols="2">
                    <b-form-group :label="$lang.PCI.PurchaseOrder.Detail.LabelDiscount">
                      <b-form-input type="number" disabled v-model="purchaseDetail.desconto"></b-form-input>
                    </b-form-group>
                  </b-col>
                  <b-col cols="2">
                    <b-form-group :label="$lang.PCI.PurchaseOrder.Detail.LabelFreight">
                      <b-form-input type="number" disabled v-model="purchaseDetail.frete"></b-form-input>
                    </b-form-group>
                  </b-col>
                  <b-col cols="2" class="d-flex align-items-center">
                    <div class="d-flex flex-column">
                      <b-form-group>
                        <b-form-checkbox disabled v-model="purchaseDetail.compraAntecipada">{{ $lang.PCI.PurchaseOrder.Detail.LabelAdvancedPurchase }}</b-form-checkbox>
                      </b-form-group>
                      <b-form-group>
                        <b-form-checkbox disabled v-model="purchaseDetail.bloqueada">{{ $lang.PCI.PurchaseOrder.Detail.LabelBlocked }}</b-form-checkbox>
                      </b-form-group>
                    </div>
                  </b-col>
                </b-row>
              </b-card>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="8">
              <b-card :header="$lang.PCI.PurchaseOrder.Detail.CardItems" class="m-2">
                <b-table striped small :items="purchaseItems" :fields="purchaseItemsFields"></b-table>
              </b-card>
            </b-col>
            <b-col cols="4" class="pl-0">
              <b-card :header="$lang.PCI.PurchaseOrder.Detail.CardFinancial" class="m-2">
                <b-table striped small :items="purchaseParcels" :fields="purchaseParcelsFields"></b-table>
              </b-card>
            </b-col>
          </b-row>
        </b-tab>
        <b-tab :title="$lang.PCI.PurchaseOrder.Detail.TabObservation" style="height: calc(100vh - 250px);">
          <b-row class="h-100">
            <b-col class="h-100">
              <b-form-textarea disabled no-auto-shrink no-resize v-model="purchaseDetail.observacao" class="h-100"></b-form-textarea>
            </b-col>
          </b-row>
        </b-tab>
        <b-tab :title="$lang.PCI.PurchaseOrder.Detail.TabAttachment">
          <b-table striped small selectable select-mode="single" :items="purchaseAttachments" :fields="purchaseAttachmentsFields" @row-selected="onSelectAttachment"></b-table>
          <b-button variant="third" v-if="purchaseAttachmentSelected.length" @click="onDownloadAttachment"><i class="fas fa-download"></i></b-button>
        </b-tab>
      </b-tabs>
    </div>
  </b-modal>
</template>

<script>
import ZSistemaRepository from '@/shared/http/repositories/business/zsystem'
import { AgGridVue } from 'ag-grid-vue'
import gridMixin from '../../mixins/gridMixin'
import { loading } from '@/shared/utils/UIHelper'
import CompanyMixin from '@/store/module/company/mixin'
import moment from 'moment'

export default {
  name: 'PurchaseOrder',
  components: {
    AgGridVue
  },
  mixins: [gridMixin, CompanyMixin],
  computed: {
    valorEntregue () {
      const sumValue = this.data.filter(d => d.situacao === 'ENTREGUE').reduce((acc, curr) => acc + curr.valor, 0.00)
      return sumValue.toLocaleString('pt-BR', {style: 'decimal', minimumFractionDigits: 2, maximumFractionDigits: 2})
    },
    valorAEntregar () {
      const sumValue = this.data.filter(d => d.situacao !== 'ENTREGUE').reduce((acc, curr) => acc + curr.valor, 0.00)
      return sumValue.toLocaleString('pt-BR', {style: 'decimal', minimumFractionDigits: 2, maximumFractionDigits: 2})
    },
    valorTotal () {
      const sumValue = this.data.reduce((acc, curr) => acc + curr.valor, 0.00)
      return sumValue.toLocaleString('pt-BR', {style: 'decimal', minimumFractionDigits: 2, maximumFractionDigits: 2})
    }
  },
  data () {
    return {
      data: [],
      pci: {},
      purchaseOrderGridOptions: {},
      rowSelected: null,
      purchaseDetail: null,
      purchaseItems: null,
      purchaseParcels: null,
      purchaseAttachments: null,
      purchaseAttachmentSelected: [],
      purchaseItemsFields: [
        { key: 'item', label: this.$lang.PCI.PurchaseOrder.Detail.ItemsDatatable.Item },
        { key: 'material', label: this.$lang.PCI.PurchaseOrder.Detail.ItemsDatatable.Code },
        { key: 'descricao', label: this.$lang.PCI.PurchaseOrder.Detail.ItemsDatatable.Description },
        { key: 'unidade', label: this.$lang.PCI.PurchaseOrder.Detail.ItemsDatatable.Unity },
        {
          key: 'quantidade',
          label: this.$lang.PCI.PurchaseOrder.Detail.ItemsDatatable.Quantity,
          class: 'text-right',
          formatter: value => {
            return value ? value.toLocaleString('pt-BR', {style: 'decimal', minimumFractionDigits: 2, maximumFractionDigits: 2}) : ''
          }
        },
        {
          key: 'valor',
          label: this.$lang.PCI.PurchaseOrder.Detail.ItemsDatatable.Value,
          class: 'text-right',
          formatter: value => {
            return value ? value.toLocaleString('pt-BR', {style: 'decimal', minimumFractionDigits: 2, maximumFractionDigits: 2}) : ''
          }
        },
        {
          key: 'total',
          class: 'text-right',
          formatter: (value, key, item) => {
            let total = 0.00
            total = (item.quantidade || 0.00) * (item.valor || 0.00)
            return total.toLocaleString('pt-BR', {style: 'decimal', minimumFractionDigits: 2, maximumFractionDigits: 2})
          }
        }
      ],
      purchaseParcelsFields: [
        {
          key: 'vencimento',
          label: this.$lang.PCI.PurchaseOrder.Detail.FinancialDatatable.DueDate,
          formatter: value => {
            return value ? moment(value).toDate().toLocaleDateString() : ''
          }
        },
        {
          key: 'previsao',
          label: this.$lang.PCI.PurchaseOrder.Detail.FinancialDatatable.Forecast,
          formatter: value => {
            return value ? moment(value).toDate().toLocaleDateString() : ''
          }
        },
        {
          key: 'entrega',
          label: this.$lang.PCI.PurchaseOrder.Detail.FinancialDatatable.Delivery,
          formatter: value => {
            return value ? moment(value).toDate().toLocaleDateString() : ''
          }
        },
        {
          key: 'valor',
          label: this.$lang.PCI.PurchaseOrder.Detail.FinancialDatatable.Value,
          class: 'text-right',
          formatter: value => {
            return value ? value.toLocaleString('pt-BR', {style: 'decimal', minimumFractionDigits: 2, maximumFractionDigits: 2}) : ''
          }
        }
      ],
      purchaseAttachmentsFields: [
        { key: 'descricao', label: this.$lang.PCI.PurchaseOrder.Detail.AttachmentDatatable.Description },
        { key: 'nome', label: this.$lang.PCI.PurchaseOrder.Detail.AttachmentDatatable.Name }
      ],
      defaultColumnDef: {
        filter: 'agSetColumnFilter',
        floatingFilter: false,
        resizable: true,
        editable: false,
        suppressMenu: false,
        sortable: true,
        enableRowGroup: true,
        width: 100,
        minWidth: 80
      },
      purchaseExcelStyles: [],
      columnDefs: [
        {
          headerName: this.$lang.PCI.PurchaseOrder.Datatable.Order,
          field: 'ordem',
          flex: 40
        },
        {
          headerName: this.$lang.PCI.PurchaseOrder.Datatable.Request,
          field: 'pedido',
          flex: 40
        },
        {
          headerName: this.$lang.PCI.PurchaseOrder.Datatable.Provider,
          field: 'codigoFornecedor',
          flex: 40
        },
        {
          headerName: this.$lang.PCI.PurchaseOrder.Datatable.CorporateName,
          field: 'nomeFornecedor',
          flex: 100
        },
        {
          headerName: this.$lang.PCI.PurchaseOrder.Datatable.IssueDate,
          field: 'dataEmissao',
          type: 'dateColumn',
          flex: 40
        },
        {
          headerName: this.$lang.PCI.PurchaseOrder.Datatable.Value,
          field: 'valor',
          type: 'numberColumn',
          flex: 40
        },
        {
          headerName: this.$lang.PCI.PurchaseOrder.Datatable.Situation,
          field: 'situacao',
          flex: 40
        }
      ]
    }
  },
  methods: {
    show (pci) {
      this.purchaseExcelStyles = [...this.excelStyles,
        {
          id: 'title',
          alignment: {
            vertical: 'Center'
          },
          interior: {
            color: '#046437',
            pattern: 'solid'
          },
          font: {
            bold: true,
            color: '#FFFFFF',
            size: 18
          }
        },
        {
          id: 'footer',
          font: {
            bold: true
          }
        }
      ]

      this.pci = pci
      loading.push()
      ZSistemaRepository.GetAllPurchaseOrder(pci.obraId)
        .then(response => {
          if (response.data.code > 0) {
            this.data = response.data.data
            this.$refs.purchase.show()
          }
        })
        .finally(() => loading.close())
    },
    parseDate (date) {
      if (date) {
        return moment(date).toDate().toLocaleDateString()
      }
    },
    onSelect (params) {
      const data = params.node.data
      loading.push()
      ZSistemaRepository.GetPurchaseOrderDetail(this.company.id, data.ordem)
        .then(response => {
          if (response.data.code > 0) {
            this.purchaseDetail = response.data.data
            this.purchaseDetail.emissao = this.parseDate(response.data.data.emissao)
          }
        })
        .then(() => {
          ZSistemaRepository.GetPurchaseOrderItems(this.company.id, data.ordem)
            .then(response => {
              if (response.data.code > 0) {
                this.purchaseItems = response.data.data
              }
            })
            .then(() => {
              ZSistemaRepository.GetPurchaseOrderParcels(this.company.id, data.ordem)
                .then(response => {
                  if (response.data.code > 0) {
                    this.purchaseParcels = response.data.data
                  }
                })
                .then(() => {
                  ZSistemaRepository.GetPurchaseOrderAttachments(this.company.id, data.ordem)
                    .then(response => {
                      if (response.data.code > 0) {
                        this.purchaseAttachments = response.data.data
                      }
                    })
                    .finally(() => {
                      loading.close()
                      this.rowSelected = data
                    })
                })
            })
        })
    },
    onShowGrid () {
      this.rowSelected = null
      this.purchaseDetail = null
      this.purchaseItems = null
      this.purchaseParcels = null
      this.purchaseAttachments = null
      this.$nextTick(() => {
        this.purchaseOrderGridOptions.api.sizeColumnsToFit()
      })
    },
    onSelectAttachment (item) {
      this.purchaseAttachmentSelected = item
    },
    onDownloadAttachment () {
      const file = this.purchaseAttachmentSelected[0].arquivo
      const data = Uint8Array.from(atob(file), c => c.charCodeAt(0))
      const blob = new Blob([data], {type: 'application/pdf'})
      const link = document.createElement('a')
      link.href = window.URL.createObjectURL(blob)
      link.download = this.purchaseAttachmentSelected[0].nome
      link.click()
      URL.revokeObjectURL(link.href)
    },
    onClose () {
      this.$refs.purchase.hide()
      this.$emit('close')
    },
    exportExcel () {
      const totalValue = this.data.reduce((acc, curr) => acc + curr.valor, 0.00)
      const toDeliverValue = this.data.filter(d => d.situacao !== 'ENTREGUE').reduce((acc, curr) => acc + curr.valor, 0.00)
      const deliveredValue = this.data.filter(d => d.situacao === 'ENTREGUE').reduce((acc, curr) => acc + curr.valor, 0.00)
      const append = () => ({
        prependContent: [
          {cells: [
            {data: {value: '', type: 'String'}, styleId: 'title', mergeAcross: 6}
          ]},
          {cells: [
            {data: {value: 'Ordens de Compra', type: 'String'}, styleId: 'title', mergeAcross: 6}
          ]},
          {cells: [
            {data: {value: '', type: 'String'}, styleId: 'title', mergeAcross: 6}
          ]}
        ],
        appendContent: [
          {cells: []},
          {cells: [
            {data: {value: null}},
            {data: {value: null}},
            {data: {value: null}},
            {data: {value: null}},
            {data: {value: 'Entregue', type: 'String'}, styleId: ['ag-right-aligned-cell', 'footer']},
            {data: {value: deliveredValue, type: 'Number'}, styleId: ['floatType', 'footer']}
          ]},
          {cells: [
            {data: {value: null}},
            {data: {value: null}},
            {data: {value: null}},
            {data: {value: null}},
            {data: {value: 'À Entregar', type: 'String'}, styleId: ['ag-right-aligned-cell', 'footer']},
            {data: {value: toDeliverValue, type: 'Number'}, styleId: ['floatType', 'footer']}
          ]},
          {cells: [
            {data: {value: null}},
            {data: {value: null}},
            {data: {value: null}},
            {data: {value: null}},
            {data: {value: 'Total', type: 'String'}, styleId: ['ag-right-aligned-cell', 'footer']},
            {data: {value: totalValue, type: 'Number'}, styleId: ['floatType', 'footer']}
          ]}
        ]
      })
      this.purchaseOrderGridOptions.api.exportDataAsExcel(append())
    },
    onPrint () {
      loading.push()
      ZSistemaRepository.PrintPurchaseOrder(this.company.id, this.rowSelected.ordem)
        .then(response => {
          if (response.data.code > 0) {
            const binary = window.atob(response.data.data.replace(/\s/g, ''))
            const len = binary.length
            const buffer = new ArrayBuffer(len)
            const view = new Uint8Array(buffer)
            for (let i = 0; i < len; i++) {
              view[i] = binary.charCodeAt(i)
            }
            const blob = new Blob([view], {type: 'application/pdf'})

            const fileURL = URL.createObjectURL(blob)
            window.open(fileURL)
          }
        })
        .catch(err => console.log(err))
        .finally(() => loading.close())
    }
  }
}
</script>

<style scoped>
* >>> .modal-header {
  border-top-left-radius: 25px;
  border-top-right-radius: 25px;
}
* >>> .modal-body {
  border-bottom-left-radius: 25px;
  border-bottom-right-radius: 25px;
  overflow: hidden;
}
* >>> .modal-footer {
  border-bottom-left-radius: 25px;
  border-bottom-right-radius: 25px;
}
* >>> .modal-content {
  border-radius: 25px;
}
</style>



// WEBPACK FOOTER //
// src/views/private/operational/pci/components/purchaseorder/purchaseorder.vue